import { BaseMapper } from '@/core/mapper';

const schema = {
  id: {
    parseFrom: 'id',
  },
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  name: {
    parseFrom: 'attributes.name',
  },
  iso_code: {
    parseFrom: 'attributes.iso_code',
  },
  tax_amount: {
    fromResponse: (entity) => {
      const parsedTaxAmount = _.get(entity, 'attributes.tax_amount');
      return parsedTaxAmount ? parseFloat(parsedTaxAmount) : 0;
    },
  },
  tax_name: {
    parseFrom: 'attributes.tax_name',
  },
};

class Country extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

Country.schema = schema;

export default Country;
